
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscfb7dc48ea1c6b8c83d3a283b00609c2en from './en.yaml'
            i18n.addResourceBundle('en', 'cfb7dc48ea1c6b8c83d3a283b00609c2', flattenObject(nscfb7dc48ea1c6b8c83d3a283b00609c2en), true, true);
        
        export default 'cfb7dc48ea1c6b8c83d3a283b00609c2';
    